<template>
  <div class="index">
    <div class="information-container">
      <draggable class="is-multiline documents" v-if="data" v-model="data">
        <BankRequirementItem v-for="information in data" :information="information" :key="information.id"/>
      </draggable>
      <div class="centered add-document">
        <span class="button-wrapper link" @click="handleAddRequiredInformation()">
          <a class="button is-info">+</a> Добавить информацию
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import BankRequirementItem from 'components/Information/BankRequirementItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'
import uuidv4 from 'uuid/v4'

export default {
  name: 'BankRequirement',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['requiredInformation']),
    data: {
      get () {
        return deepcopy(this.requiredInformation)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.bankRequirementOrder(val)
      }
    }
  },
  created () {
    this.getRequiredInformation()
  },
  methods: {
    ...mapActions(['getRequiredInformation', 'addRequiredInformation', 'bankRequirementOrder']),
    handleAddRequiredInformation () {
      this.addRequiredInformation({
        id: uuidv4(),
        requiredInformationFiles: [],
        requiredInformationRows: [],
        requiredInformationBookkeepings: [],
        url: '',
        order: this.requiredInformation.length + 1
      })
    }
  },
  components: { draggable, BankRequirementItem }
}
</script>

<style scoped>
.information-container {
  padding: 25px 0 60px;
  margin: 15px 0 0;
  max-width: 1300px;
  margin: 0 auto;
}
.documents {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// BankRequirement.vue?b5b1caf8